module.exports = __webpack_public_path__ + "static/media/light-theme-adblue-fault.027a9e54.svg";